module.exports = __webpack_public_path__ + "img/border_Corner_Right.57fb7e79.svg";